import {trigger} from '../lib/events';

window.tarteaucitron && (window.tarteaucitron.services.rdlv_vimeo = {
    "key": "rdlv_vimeo",
    "type": "video",
    "name": "Vimeo",
    "uri": "http://vimeo.com/privacy",
    "needConsent": true,
    "cookies": ['__utmt_player', '__utma', '__utmb', '__utmc', '__utmv', 'vuid', '__utmz', 'player'],
    "js": function () {
        "use strict";
        window.tarteaucitron.fallback(['vimeo_player'], function (node) {
            if (!window.vimeoApi && node.getAttribute('data-api') === 'true') {
                // https://developer.vimeo.com/player/sdk/basics
                window.vimeoApi = true;
                var playerApi = document.createElement('script');
                playerApi.setAttribute('src', 'https://player.vimeo.com/api/player.js');
                playerApi.setAttribute('async', 'true');
                document.body.appendChild(playerApi);
                playerApi.onload = function () {
                    Array.prototype.forEach.call(document.querySelectorAll('iframe[data-provider="vimeo"]'), function (iframe) {
                        var player = new window.Vimeo.Player(iframe);
                        player.on('play', function () {
                            trigger.call(iframe, 'play');
                        });
                        player.on('pause', function () {
                            trigger.call(iframe, 'pause');
                        });
                    });
                };
            }

            const html =node.getAttribute('data-tac-html');
            node.removeAttribute('style');
            node.removeAttribute('data-tac-html');
            return html;
        });
    },
    "fallback": function () {
        "use strict";
        var id = 'rdlv_vimeo';
        window.tarteaucitron.fallback(['vimeo_player'], function () {
            return window.tarteaucitron.engage(id);
        });
    }
});
